export enum ToastType {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
}
